export default __webpack_public_path__ + "static/media/Tonmoy-Talukder-Resume-Full-Stack-Developer.0df17f30.pdf";